import React, { useState, useEffect } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import axios from "axios";
import { FaList, FaSitemap, FaFileInvoiceDollar } from "react-icons/fa";

// Reusable Stat Card Component for Cash Dashboard
const CashStatCard = ({ title, value, icon, color }) => (
  <Col md={4} className="mb-4">
    <Card
      className="shadow-sm h-100"
      style={{ borderLeft: `5px solid ${color}` }}
    >
      <Card.Body className="d-flex justify-content-between align-items-center">
        <div>
          <h6 className="text-muted mb-1" style={{ color: color }}>
            {title}
          </h6>
          <h3 className="fw-bold mb-0">{value}</h3>
        </div>
        <div
          className="icon-circle"
          style={{ backgroundColor: `${color}20`, color: color }}
        >
          {icon}
        </div>
      </Card.Body>
    </Card>
  </Col>
);

function CashDashboard() {
  const [stats, setStats] = useState({
    totalCategories: 0,
    totalSubCategories: 0,
    totalChalans: 0,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const fetchStats = async () => {
      setStats((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const token = localStorage.getItem("token");
        const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;

        // Fetch categories
        let totalCategories = 0;
        try {
          const categoriesResponse = await axios.get(`${API_URL}cash_catagory_list.php`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (categoriesResponse.data.success) {
            totalCategories = categoriesResponse.data.data.length;
          } else {
            totalCategories = 0;
          }
        } catch (error) {
          if (error.response && (error.response.status === 400 || error.response.status === 404)) {
            totalCategories = 0;
          } else {
            throw error;
          }
        }

        // Fetch subcategories
        let totalSubCategories = 0;
        try {
          const subCategoriesResponse = await axios.get(`${API_URL}cash_subcatagory_list.php`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (subCategoriesResponse.data.success) {
            totalSubCategories = subCategoriesResponse.data.data.length;
          } else {
            totalSubCategories = 0;
          }
        } catch (error) {
          if (error.response && (error.response.status === 400 || error.response.status === 404)) {
            totalSubCategories = 0;
          } else {
            throw error;
          }
        }

        // Fetch chalans
        let totalChalans = 0;
        try {
          const chalansResponse = await axios.get(`${API_URL}cash_chalan_list.php`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (chalansResponse.data.status === 'success') {
            totalChalans = chalansResponse.data.data.length;
          } else if (chalansResponse.data.status === 'error') {
            totalChalans = 0;
          } else {
            totalChalans = 0;
          }
        } catch (error) {
          if (error.response && (error.response.status === 400 || error.response.status === 404)) {
            totalChalans = 0;
          } else {
            throw error;
          }
        }

        setStats({
          totalCategories,
          totalSubCategories,
          totalChalans,
          loading: false,
          error: null,
        });
      } catch (error) {
        console.error("Error fetching cash dashboard stats:", error);
        setStats({
          totalCategories: 0,
          totalSubCategories: 0,
          totalChalans: 0,
          loading: false,
          error: error.message,
        });
      }
    };

    fetchStats();
  }, []);

  if (stats.loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" />
        <p className="mt-2">Loading dashboard data...</p>
      </div>
    );
  }

  if (stats.error) {
    return (
      <div className="text-center p-5">
        <div className="alert alert-danger">
          Error loading dashboard: {stats.error}
        </div>
      </div>
    );
  }

  return (
    <Row>
      <CashStatCard
        title="Total Categories"
        value={stats.totalCategories}
        icon={<FaList />}
        color="#0d6efd"
      />
      <CashStatCard
        title="Total Subcategories"
        value={stats.totalSubCategories}
        icon={<FaSitemap />}
        color="#198754"
      />
      <CashStatCard
        title="Total Chalans"
        value={stats.totalChalans}
        icon={<FaFileInvoiceDollar />}
        color="#ffc107"
      />
    </Row>
  );
}

export default CashDashboard;
